@file:OptIn(InternalResourceApi::class)

package gero.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/gero.composeapp.generated.resources/"

@delegate:ResourceContentHash(2_038_019_582)
internal val Res.string.exp_content_un_attimo_6: StringResource by lazy {
      StringResource("string:exp_content_un_attimo_6", "exp_content_un_attimo_6", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 138274, 139),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 135882, 143),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 137891, 147),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 130742, 139),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 127710, 115),
      ))
    }

@delegate:ResourceContentHash(-654_199_074)
internal val Res.string.exp_content_un_attimo_7: StringResource by lazy {
      StringResource("string:exp_content_un_attimo_7", "exp_content_un_attimo_7", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 138414, 119),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 136026, 135),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 138039, 123),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 130882, 127),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 127826, 119),
      ))
    }

@delegate:ResourceContentHash(139_341_031)
internal val Res.string.exp_content_un_attimo_8: StringResource by lazy {
      StringResource("string:exp_content_un_attimo_8", "exp_content_un_attimo_8", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 138534, 39),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 136162, 43),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 138163, 43),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 131010, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 127946, 39),
      ))
    }

@delegate:ResourceContentHash(-1_520_673_026)
internal val Res.string.exp_content_un_attimo_9: StringResource by lazy {
      StringResource("string:exp_content_un_attimo_9", "exp_content_un_attimo_9", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 138574, 67),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 136206, 71),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 138207, 67),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 131050, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 127986, 67),
      ))
    }

@delegate:ResourceContentHash(-1_489_923_772)
internal val Res.string.exp_content_un_bel_quiz_ripassone: StringResource by lazy {
      StringResource("string:exp_content_un_bel_quiz_ripassone", "exp_content_un_bel_quiz_ripassone", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 138642, 93),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 136278, 77),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 138275, 85),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 131118, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 128054, 69),
      ))
    }

@delegate:ResourceContentHash(-1_069_495_998)
internal val Res.string.exp_content_un_seguace_eccellente_1: StringResource by lazy {
      StringResource("string:exp_content_un_seguace_eccellente_1", "exp_content_un_seguace_eccellente_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 139328, 99),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 136932, 107),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 138953, 111),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 131740, 99),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 128668, 99),
      ))
    }

@delegate:ResourceContentHash(482_179_542)
internal val Res.string.exp_content_un_seguace_eccellente_10: StringResource by lazy {
      StringResource("string:exp_content_un_seguace_eccellente_10", "exp_content_un_seguace_eccellente_10", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 138736, 172),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 136356, 148),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 138361, 168),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 131192, 144),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 128124, 152),
      ))
    }

@delegate:ResourceContentHash(928_818_738)
internal val Res.string.exp_content_un_seguace_eccellente_11: StringResource by lazy {
      StringResource("string:exp_content_un_seguace_eccellente_11", "exp_content_un_seguace_eccellente_11", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 138909, 184),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 136505, 180),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 138530, 180),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 131337, 172),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 128277, 172),
      ))
    }

@delegate:ResourceContentHash(-2_069_485_602)
internal val Res.string.exp_content_un_seguace_eccellente_12: StringResource by lazy {
      StringResource("string:exp_content_un_seguace_eccellente_12", "exp_content_un_seguace_eccellente_12", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 139094, 108),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 136686, 116),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 138711, 112),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 131510, 104),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 128450, 104),
      ))
    }

@delegate:ResourceContentHash(-1_018_785_777)
internal val Res.string.exp_content_un_seguace_eccellente_13: StringResource by lazy {
      StringResource("string:exp_content_un_seguace_eccellente_13", "exp_content_un_seguace_eccellente_13", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 139203, 124),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 136803, 128),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 138824, 128),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 131615, 124),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 128555, 112),
      ))
    }

@delegate:ResourceContentHash(555_038_270)
internal val Res.string.exp_content_un_seguace_eccellente_2: StringResource by lazy {
      StringResource("string:exp_content_un_seguace_eccellente_2", "exp_content_un_seguace_eccellente_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 139428, 135),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 137040, 131),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 139065, 119),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 131840, 119),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 128768, 115),
      ))
    }

@delegate:ResourceContentHash(-1_174_863_636)
internal val Res.string.exp_content_un_seguace_eccellente_3: StringResource by lazy {
      StringResource("string:exp_content_un_seguace_eccellente_3", "exp_content_un_seguace_eccellente_3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 139564, 123),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 137172, 131),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 139185, 139),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 131960, 127),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 128884, 119),
      ))
    }

@delegate:ResourceContentHash(706_669_046)
internal val Res.string.exp_content_un_seguace_eccellente_4: StringResource by lazy {
      StringResource("string:exp_content_un_seguace_eccellente_4", "exp_content_un_seguace_eccellente_4", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 139688, 63),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 137304, 67),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 139325, 63),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 132088, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 129004, 59),
      ))
    }

@delegate:ResourceContentHash(-1_492_458_342)
internal val Res.string.exp_content_un_seguace_eccellente_5: StringResource by lazy {
      StringResource("string:exp_content_un_seguace_eccellente_5", "exp_content_un_seguace_eccellente_5", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 139752, 107),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 137372, 127),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 139389, 127),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 132148, 107),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 129064, 103),
      ))
    }

@delegate:ResourceContentHash(2_115_921_699)
internal val Res.string.exp_content_un_seguace_eccellente_6: StringResource by lazy {
      StringResource("string:exp_content_un_seguace_eccellente_6", "exp_content_un_seguace_eccellente_6", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 139860, 143),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 137500, 135),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 139517, 139),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 132256, 131),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 129168, 127),
      ))
    }

@delegate:ResourceContentHash(1_748_203_565)
internal val Res.string.exp_content_un_seguace_eccellente_7: StringResource by lazy {
      StringResource("string:exp_content_un_seguace_eccellente_7", "exp_content_un_seguace_eccellente_7", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 140004, 95),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 137636, 95),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 139657, 103),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 132388, 103),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 129296, 107),
      ))
    }

@delegate:ResourceContentHash(-388_902_798)
internal val Res.string.exp_content_un_seguace_eccellente_8: StringResource by lazy {
      StringResource("string:exp_content_un_seguace_eccellente_8", "exp_content_un_seguace_eccellente_8", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 140100, 171),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 137732, 151),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 139761, 155),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 132492, 135),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 129404, 139),
      ))
    }

@delegate:ResourceContentHash(168_078_460)
internal val Res.string.exp_content_un_seguace_eccellente_9: StringResource by lazy {
      StringResource("string:exp_content_un_seguace_eccellente_9", "exp_content_un_seguace_eccellente_9", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 140272, 59),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 137884, 67),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 139917, 63),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 132628, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 129544, 59),
      ))
    }

@delegate:ResourceContentHash(151_733_215)
internal val Res.string.exp_content_una_definizione_1: StringResource by lazy {
      StringResource("string:exp_content_una_definizione_1", "exp_content_una_definizione_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 141315, 97),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 138907, 89),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 140992, 85),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 133615, 93),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 130531, 85),
      ))
    }

@delegate:ResourceContentHash(-1_452_971_288)
internal val Res.string.exp_content_una_definizione_10: StringResource by lazy {
      StringResource("string:exp_content_una_definizione_10", "exp_content_una_definizione_10", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 140332, 66),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 137952, 62),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 139981, 66),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 132688, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 129604, 62),
      ))
    }

@delegate:ResourceContentHash(-279_965_919)
internal val Res.string.exp_content_una_definizione_11: StringResource by lazy {
      StringResource("string:exp_content_una_definizione_11", "exp_content_una_definizione_11", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 140399, 94),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 138015, 90),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 140048, 94),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 132751, 86),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 129667, 90),
      ))
    }

@delegate:ResourceContentHash(-254_728_837)
internal val Res.string.exp_content_una_definizione_12: StringResource by lazy {
      StringResource("string:exp_content_una_definizione_12", "exp_content_una_definizione_12", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 140494, 154),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 138106, 130),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 140143, 146),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 132838, 126),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 129758, 134),
      ))
    }

@delegate:ResourceContentHash(-1_300_434_316)
internal val Res.string.exp_content_una_definizione_13: StringResource by lazy {
      StringResource("string:exp_content_una_definizione_13", "exp_content_una_definizione_13", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 140649, 222),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 138237, 222),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 140290, 238),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 132965, 218),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 129893, 214),
      ))
    }

@delegate:ResourceContentHash(-546_884_996)
internal val Res.string.exp_content_una_definizione_14: StringResource by lazy {
      StringResource("string:exp_content_una_definizione_14", "exp_content_una_definizione_14", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 140872, 74),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 138460, 94),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 140529, 90),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 133184, 86),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 130108, 86),
      ))
    }

@delegate:ResourceContentHash(1_658_289_274)
internal val Res.string.exp_content_una_definizione_15: StringResource by lazy {
      StringResource("string:exp_content_una_definizione_15", "exp_content_una_definizione_15", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 140947, 78),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 138555, 62),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 140620, 70),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 133271, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 130195, 66),
      ))
    }

@delegate:ResourceContentHash(-858_943_157)
internal val Res.string.exp_content_una_definizione_16: StringResource by lazy {
      StringResource("string:exp_content_una_definizione_16", "exp_content_una_definizione_16", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 141026, 94),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 138618, 106),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 140691, 114),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 133338, 106),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 130262, 94),
      ))
    }

@delegate:ResourceContentHash(-976_154_079)
internal val Res.string.exp_content_una_definizione_17: StringResource by lazy {
      StringResource("string:exp_content_una_definizione_17", "exp_content_una_definizione_17", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 141121, 62),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 138725, 66),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 140806, 78),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 133445, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 130357, 66),
      ))
    }

@delegate:ResourceContentHash(1_349_475_119)
internal val Res.string.exp_content_una_definizione_18: StringResource by lazy {
      StringResource("string:exp_content_una_definizione_18", "exp_content_una_definizione_18", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 141184, 130),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 138792, 114),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 140885, 106),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 133504, 110),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 130424, 106),
      ))
    }

@delegate:ResourceContentHash(486_571_812)
internal val Res.string.exp_content_una_definizione_2: StringResource by lazy {
      StringResource("string:exp_content_una_definizione_2", "exp_content_una_definizione_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 141413, 81),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 138997, 89),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 141078, 89),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 133709, 77),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 130617, 73),
      ))
    }

@delegate:ResourceContentHash(-1_944_173_910)
internal val Res.string.exp_content_una_definizione_3: StringResource by lazy {
      StringResource("string:exp_content_una_definizione_3", "exp_content_una_definizione_3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 141495, 109),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 139087, 97),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 141168, 105),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 133787, 93),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 130691, 105),
      ))
    }

@delegate:ResourceContentHash(1_530_572_718)
internal val Res.string.exp_content_una_definizione_4: StringResource by lazy {
      StringResource("string:exp_content_una_definizione_4", "exp_content_una_definizione_4", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 141605, 57),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 139185, 57),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 141274, 57),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 133881, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 130797, 53),
      ))
    }

@delegate:ResourceContentHash(-726_238_745)
internal val Res.string.exp_content_una_definizione_5: StringResource by lazy {
      StringResource("string:exp_content_una_definizione_5", "exp_content_una_definizione_5", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 141663, 113),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 139243, 109),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 141332, 117),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 133939, 117),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 130851, 113),
      ))
    }

@delegate:ResourceContentHash(932_011_743)
internal val Res.string.exp_content_una_definizione_6: StringResource by lazy {
      StringResource("string:exp_content_una_definizione_6", "exp_content_una_definizione_6", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 141777, 105),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 139353, 109),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 141450, 105),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 134057, 101),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 130965, 105),
      ))
    }

@delegate:ResourceContentHash(-638_384_550)
internal val Res.string.exp_content_una_definizione_7: StringResource by lazy {
      StringResource("string:exp_content_una_definizione_7", "exp_content_una_definizione_7", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 141883, 193),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 139463, 197),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 141556, 185),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 134159, 185),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 131071, 177),
      ))
    }

@delegate:ResourceContentHash(444_194_602)
internal val Res.string.exp_content_una_definizione_8: StringResource by lazy {
      StringResource("string:exp_content_una_definizione_8", "exp_content_una_definizione_8", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 142077, 65),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 139661, 73),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 141742, 65),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 134345, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 131249, 65),
      ))
    }

@delegate:ResourceContentHash(2_032_461_433)
internal val Res.string.exp_content_una_definizione_9: StringResource by lazy {
      StringResource("string:exp_content_una_definizione_9", "exp_content_una_definizione_9", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 142143, 97),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 139735, 93),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 141808, 97),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 134411, 93),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 131315, 93),
      ))
    }

@delegate:ResourceContentHash(1_685_882_915)
internal val Res.string.exp_content_unendo_il_primo_segno_e_il_secondo_otteniamo_: StringResource by
    lazy {
      StringResource("string:exp_content_unendo_il_primo_segno_e_il_secondo_otteniamo_", "exp_content_unendo_il_primo_segno_e_il_secondo_otteniamo_", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 142241, 189),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 139829, 161),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 141906, 169),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 134505, 153),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 131409, 157),
      ))
    }

@delegate:ResourceContentHash(1_915_838_537)
internal val Res.string.exp_content_vediamo_la_lista_pane_e_birra_n_naccostiamo_p: StringResource by
    lazy {
      StringResource("string:exp_content_vediamo_la_lista_pane_e_birra_n_naccostiamo_p", "exp_content_vediamo_la_lista_pane_e_birra_n_naccostiamo_p", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 142431, 185),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 139991, 161),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 142076, 185),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 134659, 165),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 131567, 177),
      ))
    }

@delegate:ResourceContentHash(-503_758_523)
internal val Res.string.exp_content_vediamo_un_altro_esempio_n_la_mucca_del_pasto: StringResource by
    lazy {
      StringResource("string:exp_content_vediamo_un_altro_esempio_n_la_mucca_del_pasto", "exp_content_vediamo_un_altro_esempio_n_la_mucca_del_pasto", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 142617, 145),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 140153, 121),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 142262, 133),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 134825, 129),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 131745, 129),
      ))
    }

@delegate:ResourceContentHash(312_442_994)
internal val Res.string.exp_content_verbi_e_participi_1: StringResource by lazy {
      StringResource("string:exp_content_verbi_e_participi_1", "exp_content_verbi_e_participi_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 142763, 83),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 140275, 79),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 142396, 83),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 134955, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 131875, 75),
      ))
    }

@delegate:ResourceContentHash(16_384_603)
internal val Res.string.exp_content_verbi_e_participi_2: StringResource by lazy {
      StringResource("string:exp_content_verbi_e_participi_2", "exp_content_verbi_e_participi_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 142847, 135),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 140355, 131),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 142480, 131),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 135027, 123),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 131951, 123),
      ))
    }

@delegate:ResourceContentHash(-1_846_742_587)
internal val Res.string.exp_content_verbi_e_participi_3: StringResource by lazy {
      StringResource("string:exp_content_verbi_e_participi_3", "exp_content_verbi_e_participi_3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 142983, 55),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 140487, 55),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 142612, 55),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 135151, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 132075, 55),
      ))
    }

@delegate:ResourceContentHash(-461_271_855)
internal val Res.string.exp_content_verbi_intro_1_alyn: StringResource by lazy {
      StringResource("string:exp_content_verbi_intro_1_alyn", "exp_content_verbi_intro_1_alyn", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 143248, 210),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 140728, 190),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 142885, 186),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 135384, 186),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 132308, 186),
      ))
    }

@delegate:ResourceContentHash(299_140_822)
internal val Res.string.exp_content_verbi_intro_1_alyn_2: StringResource by lazy {
      StringResource("string:exp_content_verbi_intro_1_alyn_2", "exp_content_verbi_intro_1_alyn_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 143039, 208),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 140543, 184),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 142668, 216),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 135203, 180),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 132131, 176),
      ))
    }

@delegate:ResourceContentHash(-1_240_359_401)
internal val Res.string.exp_content_verbi_intro_1_nilo_1: StringResource by lazy {
      StringResource("string:exp_content_verbi_intro_1_nilo_1", "exp_content_verbi_intro_1_nilo_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 143459, 120),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 140919, 128),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 143072, 116),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 135571, 112),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 132495, 108),
      ))
    }

@delegate:ResourceContentHash(-520_427_362)
internal val Res.string.exp_content_verbi_intro_1_nilo_2: StringResource by lazy {
      StringResource("string:exp_content_verbi_intro_1_nilo_2", "exp_content_verbi_intro_1_nilo_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 143580, 124),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 141048, 128),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 143189, 108),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 135684, 120),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 132604, 112),
      ))
    }

@delegate:ResourceContentHash(1_249_578_435)
internal val Res.string.exp_content_verbi_intro_1_nilo_3: StringResource by lazy {
      StringResource("string:exp_content_verbi_intro_1_nilo_3", "exp_content_verbi_intro_1_nilo_3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 143705, 176),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 141177, 216),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 143298, 196),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 135805, 184),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 132717, 168),
      ))
    }

@delegate:ResourceContentHash(1_989_054_185)
internal val Res.string.exp_content_verbi_intro_1_nilo_4: StringResource by lazy {
      StringResource("string:exp_content_verbi_intro_1_nilo_4", "exp_content_verbi_intro_1_nilo_4", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 143882, 164),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 141394, 148),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 143495, 164),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 135990, 136),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 132886, 140),
      ))
    }

@delegate:ResourceContentHash(1_134_143_917)
internal val Res.string.exp_content_verbi_intro_1_nilo_5: StringResource by lazy {
      StringResource("string:exp_content_verbi_intro_1_nilo_5", "exp_content_verbi_intro_1_nilo_5", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 144047, 196),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 141543, 180),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 143660, 192),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 136127, 172),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 133027, 172),
      ))
    }

@delegate:ResourceContentHash(1_679_227_717)
internal val Res.string.exp_content_verbi_intro_1_nilo_6: StringResource by lazy {
      StringResource("string:exp_content_verbi_intro_1_nilo_6", "exp_content_verbi_intro_1_nilo_6", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 144244, 44),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 141724, 44),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 143853, 44),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 136300, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 133200, 44),
      ))
    }

@delegate:ResourceContentHash(-371_142_563)
internal val Res.string.exp_content_verbi_intro_1_nilo_7: StringResource by lazy {
      StringResource("string:exp_content_verbi_intro_1_nilo_7", "exp_content_verbi_intro_1_nilo_7", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 144289, 48),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 141769, 44),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 143898, 48),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 136345, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 133245, 44),
      ))
    }

@delegate:ResourceContentHash(1_830_718_279)
internal val Res.string.exp_content_verbi_sostantivati_1: StringResource by lazy {
      StringResource("string:exp_content_verbi_sostantivati_1", "exp_content_verbi_sostantivati_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 145366, 144),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 142890, 128),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 145059, 120),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 137338, 120),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 134258, 128),
      ))
    }

@delegate:ResourceContentHash(-1_781_883_237)
internal val Res.string.exp_content_verbi_sostantivati_10: StringResource by lazy {
      StringResource("string:exp_content_verbi_sostantivati_10", "exp_content_verbi_sostantivati_10", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 144338, 57),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 141814, 65),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 143947, 61),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 136390, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 133290, 57),
      ))
    }

@delegate:ResourceContentHash(-992_053_818)
internal val Res.string.exp_content_verbi_sostantivati_11: StringResource by lazy {
      StringResource("string:exp_content_verbi_sostantivati_11", "exp_content_verbi_sostantivati_11", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 144396, 77),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 141880, 89),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 144009, 85),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 136448, 77),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 133348, 81),
      ))
    }

@delegate:ResourceContentHash(-1_859_802_795)
internal val Res.string.exp_content_verbi_sostantivati_12: StringResource by lazy {
      StringResource("string:exp_content_verbi_sostantivati_12", "exp_content_verbi_sostantivati_12", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 144474, 189),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 141970, 177),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 144095, 205),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 136526, 153),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 133430, 185),
      ))
    }

@delegate:ResourceContentHash(1_869_724_466)
internal val Res.string.exp_content_verbi_sostantivati_13: StringResource by lazy {
      StringResource("string:exp_content_verbi_sostantivati_13", "exp_content_verbi_sostantivati_13", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 144664, 125),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 142148, 133),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 144301, 133),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 136680, 121),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 133616, 113),
      ))
    }

@delegate:ResourceContentHash(-1_920_256_868)
internal val Res.string.exp_content_verbi_sostantivati_14: StringResource by lazy {
      StringResource("string:exp_content_verbi_sostantivati_14", "exp_content_verbi_sostantivati_14", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 144790, 69),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 142282, 65),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 144435, 69),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 136802, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 133730, 69),
      ))
    }

@delegate:ResourceContentHash(1_312_841_134)
internal val Res.string.exp_content_verbi_sostantivati_15: StringResource by lazy {
      StringResource("string:exp_content_verbi_sostantivati_15", "exp_content_verbi_sostantivati_15", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 144860, 85),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 142348, 89),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 144505, 93),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 136876, 89),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 133800, 77),
      ))
    }

@delegate:ResourceContentHash(666_940_383)
internal val Res.string.exp_content_verbi_sostantivati_16: StringResource by lazy {
      StringResource("string:exp_content_verbi_sostantivati_16", "exp_content_verbi_sostantivati_16", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 144946, 85),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 142438, 97),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 144599, 133),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 136966, 93),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 133878, 101),
      ))
    }

@delegate:ResourceContentHash(663_991_787)
internal val Res.string.exp_content_verbi_sostantivati_17: StringResource by lazy {
      StringResource("string:exp_content_verbi_sostantivati_17", "exp_content_verbi_sostantivati_17", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 145032, 141),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 142536, 153),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 144733, 105),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 137060, 85),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 133980, 89),
      ))
    }

@delegate:ResourceContentHash(351_955_717)
internal val Res.string.exp_content_verbi_sostantivati_18: StringResource by lazy {
      StringResource("string:exp_content_verbi_sostantivati_18", "exp_content_verbi_sostantivati_18", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 145174, 105),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 142690, 109),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 144839, 109),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 137146, 97),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 134070, 101),
      ))
    }

@delegate:ResourceContentHash(-1_620_464_549)
internal val Res.string.exp_content_verbi_sostantivati_19: StringResource by lazy {
      StringResource("string:exp_content_verbi_sostantivati_19", "exp_content_verbi_sostantivati_19", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 145280, 85),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 142800, 89),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 144949, 109),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 137244, 93),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 134172, 85),
      ))
    }

@delegate:ResourceContentHash(201_251_138)
internal val Res.string.exp_content_verbi_sostantivati_2: StringResource by lazy {
      StringResource("string:exp_content_verbi_sostantivati_2", "exp_content_verbi_sostantivati_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 145511, 128),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 143019, 108),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 145180, 128),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 137459, 116),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 134387, 116),
      ))
    }

@delegate:ResourceContentHash(-730_241_363)
internal val Res.string.exp_content_verbi_sostantivati_3: StringResource by lazy {
      StringResource("string:exp_content_verbi_sostantivati_3", "exp_content_verbi_sostantivati_3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 145640, 124),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 143128, 100),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 145309, 108),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 137576, 100),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 134504, 96),
      ))
    }

@delegate:ResourceContentHash(-753_267_662)
internal val Res.string.exp_content_verbi_sostantivati_4: StringResource by lazy {
      StringResource("string:exp_content_verbi_sostantivati_4", "exp_content_verbi_sostantivati_4", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 145765, 184),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 143229, 160),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 145418, 180),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 137677, 168),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 134601, 156),
      ))
    }

@delegate:ResourceContentHash(-10_516_536)
internal val Res.string.exp_content_verbi_sostantivati_5: StringResource by lazy {
      StringResource("string:exp_content_verbi_sostantivati_5", "exp_content_verbi_sostantivati_5", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 145950, 108),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 143390, 112),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 145599, 100),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 137846, 100),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 134758, 96),
      ))
    }

@delegate:ResourceContentHash(-77_247_972)
internal val Res.string.exp_content_verbi_sostantivati_6: StringResource by lazy {
      StringResource("string:exp_content_verbi_sostantivati_6", "exp_content_verbi_sostantivati_6", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 146059, 72),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 143503, 80),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 145700, 68),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 137947, 76),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 134855, 64),
      ))
    }

@delegate:ResourceContentHash(1_274_829_955)
internal val Res.string.exp_content_verbi_sostantivati_7: StringResource by lazy {
      StringResource("string:exp_content_verbi_sostantivati_7", "exp_content_verbi_sostantivati_7", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 146132, 64),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 143584, 72),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 145769, 76),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 138024, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 134920, 60),
      ))
    }

@delegate:ResourceContentHash(-1_651_640_891)
internal val Res.string.exp_content_verbi_sostantivati_8: StringResource by lazy {
      StringResource("string:exp_content_verbi_sostantivati_8", "exp_content_verbi_sostantivati_8", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 146197, 76),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 143657, 80),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 145846, 72),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 138093, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 134981, 64),
      ))
    }

@delegate:ResourceContentHash(-437_243_927)
internal val Res.string.exp_content_verbi_sostantivati_9: StringResource by lazy {
      StringResource("string:exp_content_verbi_sostantivati_9", "exp_content_verbi_sostantivati_9", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 146274, 100),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 143738, 96),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 145919, 96),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 138166, 96),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 135046, 96),
      ))
    }

@delegate:ResourceContentHash(1_515_150_682)
internal val Res.string.exp_content_verbi_vari_alyn_1: StringResource by lazy {
      StringResource("string:exp_content_verbi_vari_alyn_1", "exp_content_verbi_vari_alyn_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 146375, 109),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 143835, 113),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 146016, 113),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 138263, 105),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 135143, 105),
      ))
    }

@delegate:ResourceContentHash(-693_937_959)
internal val Res.string.exp_content_verbi_vari_zeta_1: StringResource by lazy {
      StringResource("string:exp_content_verbi_vari_zeta_1", "exp_content_verbi_vari_zeta_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 146485, 101),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 143949, 109),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 146130, 105),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 138369, 97),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 135249, 89),
      ))
    }

@delegate:ResourceContentHash(-1_531_751_322)
internal val Res.string.exp_content_vino_acqua_n_nil_vino_dell_acqua_non_ha_senso: StringResource by
    lazy {
      StringResource("string:exp_content_vino_acqua_n_nil_vino_dell_acqua_non_ha_senso", "exp_content_vino_acqua_n_nil_vino_dell_acqua_non_ha_senso", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 146587, 201),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 144059, 181),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 146236, 197),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 138467, 177),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 135339, 185),
      ))
    }

@delegate:ResourceContentHash(-1_967_034_362)
internal val Res.string.exp_content_vino_padre_n_nil_vino_del_padre_s_ha_senso_n_: StringResource by
    lazy {
      StringResource("string:exp_content_vino_padre_n_nil_vino_del_padre_s_ha_senso_n_", "exp_content_vino_padre_n_nil_vino_del_padre_s_ha_senso_n_", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 146789, 221),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 144241, 217),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 146434, 225),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 138645, 197),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 135525, 197),
      ))
    }

@delegate:ResourceContentHash(-379_427_431)
internal val Res.string.exp_content_vocab_animali_miit: StringResource by lazy {
      StringResource("string:exp_content_vocab_animali_miit", "exp_content_vocab_animali_miit", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 147011, 214),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 144459, 194),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 146660, 202),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 138843, 194),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 135723, 202),
      ))
    }

@delegate:ResourceContentHash(342_128_207)
internal val Res.string.exp_content_vocab_cibo_acqua: StringResource by lazy {
      StringResource("string:exp_content_vocab_cibo_acqua", "exp_content_vocab_cibo_acqua", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 147226, 164),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 144654, 152),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 146863, 160),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 139038, 148),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 135926, 152),
      ))
    }

@delegate:ResourceContentHash(-1_602_829_603)
internal val Res.string.exp_content_vocab_dei_sovrani_alyn_1: StringResource by lazy {
      StringResource("string:exp_content_vocab_dei_sovrani_alyn_1", "exp_content_vocab_dei_sovrani_alyn_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 147391, 140),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 144807, 124),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 147024, 132),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 139187, 116),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 136079, 120),
      ))
    }

@delegate:ResourceContentHash(-1_028_126_240)
internal val Res.string.exp_content_vocab_dei_sovrani_nilo_1: StringResource by lazy {
      StringResource("string:exp_content_vocab_dei_sovrani_nilo_1", "exp_content_vocab_dei_sovrani_nilo_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 147532, 152),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 144932, 148),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 147157, 160),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 139304, 152),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 136200, 148),
      ))
    }

@delegate:ResourceContentHash(-785_258_193)
internal val Res.string.exp_content_vocab_famiglia_societa_alyn_1: StringResource by lazy {
      StringResource("string:exp_content_vocab_famiglia_societa_alyn_1", "exp_content_vocab_famiglia_societa_alyn_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 147685, 169),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 145081, 145),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 147318, 161),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 139457, 149),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 136349, 145),
      ))
    }

@delegate:ResourceContentHash(-326_166_392)
internal val Res.string.exp_content_vocab_famiglia_societa_nilo_1: StringResource by lazy {
      StringResource("string:exp_content_vocab_famiglia_societa_nilo_1", "exp_content_vocab_famiglia_societa_nilo_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 147855, 145),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 145227, 129),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 147480, 153),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 139607, 133),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 136495, 133),
      ))
    }

@delegate:ResourceContentHash(-628_675_538)
internal val Res.string.exp_content_vocab_famiglia_societa_zeta_1: StringResource by lazy {
      StringResource("string:exp_content_vocab_famiglia_societa_zeta_1", "exp_content_vocab_famiglia_societa_zeta_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 148001, 129),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 145357, 113),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 147634, 117),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 139741, 113),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 136629, 117),
      ))
    }

@delegate:ResourceContentHash(-992_743_622)
internal val Res.string.exp_content_vocab_oggetti_sacri_alyn_1: StringResource by lazy {
      StringResource("string:exp_content_vocab_oggetti_sacri_alyn_1", "exp_content_vocab_oggetti_sacri_alyn_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 148131, 98),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 145471, 98),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 147752, 102),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 139855, 98),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 136747, 98),
      ))
    }

@delegate:ResourceContentHash(-628_898_273)
internal val Res.string.exp_content_vocab_oggetti_sacri_zeta_1: StringResource by lazy {
      StringResource("string:exp_content_vocab_oggetti_sacri_zeta_1", "exp_content_vocab_oggetti_sacri_zeta_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 148230, 142),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 145570, 126),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 147855, 126),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 139954, 122),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 136846, 122),
      ))
    }

@delegate:ResourceContentHash(166_407_559)
internal val Res.string.exp_content_vocab_oggetti_sacri_zeta_2: StringResource by lazy {
      StringResource("string:exp_content_vocab_oggetti_sacri_zeta_2", "exp_content_vocab_oggetti_sacri_zeta_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 148373, 134),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 145697, 122),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 147982, 118),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 140077, 114),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 136969, 114),
      ))
    }

@delegate:ResourceContentHash(370_285_619)
internal val Res.string.exp_content_vocab_umani_scriba: StringResource by lazy {
      StringResource("string:exp_content_vocab_umani_scriba", "exp_content_vocab_umani_scriba", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 148508, 298),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 145820, 270),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 148101, 270),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 140192, 258),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 137084, 266),
      ))
    }

@delegate:ResourceContentHash(1_982_453_160)
internal val Res.string.exp_content_vocab_vari_1_alyn: StringResource by lazy {
      StringResource("string:exp_content_vocab_vari_1_alyn", "exp_content_vocab_vari_1_alyn", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 148807, 133),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 146091, 141),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 148372, 145),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 140451, 145),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 137351, 117),
      ))
    }

@delegate:ResourceContentHash(1_982_453_160)
internal val Res.string.exp_content_vocab_vari_2_alyn: StringResource by lazy {
      StringResource("string:exp_content_vocab_vari_2_alyn", "exp_content_vocab_vari_2_alyn", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 148941, 133),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 146233, 141),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 148518, 145),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 140597, 145),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 137469, 117),
      ))
    }

@delegate:ResourceContentHash(-2_035_096_898)
internal val Res.string.exp_content_vocab_vari_2_cielo: StringResource by lazy {
      StringResource("string:exp_content_vocab_vari_2_cielo", "exp_content_vocab_vari_2_cielo", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 149075, 178),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 146375, 170),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 148664, 186),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 140743, 166),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 137587, 166),
      ))
    }

@delegate:ResourceContentHash(-1_971_709_221)
internal val Res.string.exp_content_vocab_varie_re_basso: StringResource by lazy {
      StringResource("string:exp_content_vocab_varie_re_basso", "exp_content_vocab_varie_re_basso", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 149254, 220),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 146546, 204),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 148851, 216),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 140910, 196),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 137754, 192),
      ))
    }

@delegate:ResourceContentHash(-2_119_935_659)
internal val Res.string.exp_content_vocab_verbi_vari_alyn_1: StringResource by lazy {
      StringResource("string:exp_content_vocab_verbi_vari_alyn_1", "exp_content_vocab_verbi_vari_alyn_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 149475, 95),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 146751, 103),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 149068, 107),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 141107, 99),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 137947, 91),
      ))
    }

@delegate:ResourceContentHash(-506_385_695)
internal val Res.string.exp_content_vocab_verbi_vari_nilo_1: StringResource by lazy {
      StringResource("string:exp_content_vocab_verbi_vari_nilo_1", "exp_content_vocab_verbi_vari_nilo_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 149571, 115),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 146855, 111),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 149176, 115),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 141207, 111),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 138039, 111),
      ))
    }

@delegate:ResourceContentHash(1_935_781_119)
internal val Res.string.exp_content_vocab_verbs_1_alyn: StringResource by lazy {
      StringResource("string:exp_content_vocab_verbs_1_alyn", "exp_content_vocab_verbs_1_alyn", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 149687, 146),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 146967, 138),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 149292, 146),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 141319, 134),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 138151, 138),
      ))
    }

@delegate:ResourceContentHash(799_730_914)
internal val Res.string.exp_content_vocab_verbs_1_nilo: StringResource by lazy {
      StringResource("string:exp_content_vocab_verbs_1_nilo", "exp_content_vocab_verbs_1_nilo", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 149834, 158),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 147106, 150),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 149439, 158),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 141454, 158),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 138290, 134),
      ))
    }

@delegate:ResourceContentHash(-1_458_970_890)
internal val Res.string.exp_content_vocab_verbs_2_alyn: StringResource by lazy {
      StringResource("string:exp_content_vocab_verbs_2_alyn", "exp_content_vocab_verbs_2_alyn", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 149993, 118),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 147257, 154),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 149598, 110),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 141613, 146),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 138425, 106),
      ))
    }

@delegate:ResourceContentHash(-1_422_620_535)
internal val Res.string.exp_content_vocab_verbs_2_nilo: StringResource by lazy {
      StringResource("string:exp_content_vocab_verbs_2_nilo", "exp_content_vocab_verbs_2_nilo", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 150112, 174),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 147412, 202),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 149709, 214),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 141760, 202),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 138532, 178),
      ))
    }

@delegate:ResourceContentHash(-551_438_946)
internal val Res.string.exp_content_vocab_verbs_3_alyn: StringResource by lazy {
      StringResource("string:exp_content_vocab_verbs_3_alyn", "exp_content_vocab_verbs_3_alyn", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 150287, 42),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 147615, 42),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 149924, 42),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 141963, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 138711, 42),
      ))
    }

@delegate:ResourceContentHash(-12_868_473)
internal val Res.string.exp_content_vocab_verbs_3_zeta: StringResource by lazy {
      StringResource("string:exp_content_vocab_verbs_3_zeta", "exp_content_vocab_verbs_3_zeta", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 150330, 126),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 147658, 142),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 149967, 122),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 142006, 142),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 138754, 122),
      ))
    }

@delegate:ResourceContentHash(1_848_239_149)
internal val Res.string.exp_content_vocab_verbs_4_alyn: StringResource by lazy {
      StringResource("string:exp_content_vocab_verbs_4_alyn", "exp_content_vocab_verbs_4_alyn", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 150457, 42),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 147801, 42),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 150090, 42),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 142149, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 138877, 42),
      ))
    }

@delegate:ResourceContentHash(1_905_196_708)
internal val Res.string.exp_content_vocab_verbs_4_zeta: StringResource by lazy {
      StringResource("string:exp_content_vocab_verbs_4_zeta", "exp_content_vocab_verbs_4_zeta", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 150500, 182),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 147844, 150),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 150133, 162),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 142192, 146),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 138920, 130),
      ))
    }

@delegate:ResourceContentHash(1_938_675_833)
internal val Res.string.exp_content_vocab_vso_1_alyn: StringResource by lazy {
      StringResource("string:exp_content_vocab_vso_1_alyn", "exp_content_vocab_vso_1_alyn", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 150683, 116),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 147995, 128),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 150296, 136),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 142339, 124),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 139051, 112),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString12Resources(map: MutableMap<String, StringResource>) {
  map.put("exp_content_un_attimo_6", Res.string.exp_content_un_attimo_6)
  map.put("exp_content_un_attimo_7", Res.string.exp_content_un_attimo_7)
  map.put("exp_content_un_attimo_8", Res.string.exp_content_un_attimo_8)
  map.put("exp_content_un_attimo_9", Res.string.exp_content_un_attimo_9)
  map.put("exp_content_un_bel_quiz_ripassone", Res.string.exp_content_un_bel_quiz_ripassone)
  map.put("exp_content_un_seguace_eccellente_1", Res.string.exp_content_un_seguace_eccellente_1)
  map.put("exp_content_un_seguace_eccellente_10", Res.string.exp_content_un_seguace_eccellente_10)
  map.put("exp_content_un_seguace_eccellente_11", Res.string.exp_content_un_seguace_eccellente_11)
  map.put("exp_content_un_seguace_eccellente_12", Res.string.exp_content_un_seguace_eccellente_12)
  map.put("exp_content_un_seguace_eccellente_13", Res.string.exp_content_un_seguace_eccellente_13)
  map.put("exp_content_un_seguace_eccellente_2", Res.string.exp_content_un_seguace_eccellente_2)
  map.put("exp_content_un_seguace_eccellente_3", Res.string.exp_content_un_seguace_eccellente_3)
  map.put("exp_content_un_seguace_eccellente_4", Res.string.exp_content_un_seguace_eccellente_4)
  map.put("exp_content_un_seguace_eccellente_5", Res.string.exp_content_un_seguace_eccellente_5)
  map.put("exp_content_un_seguace_eccellente_6", Res.string.exp_content_un_seguace_eccellente_6)
  map.put("exp_content_un_seguace_eccellente_7", Res.string.exp_content_un_seguace_eccellente_7)
  map.put("exp_content_un_seguace_eccellente_8", Res.string.exp_content_un_seguace_eccellente_8)
  map.put("exp_content_un_seguace_eccellente_9", Res.string.exp_content_un_seguace_eccellente_9)
  map.put("exp_content_una_definizione_1", Res.string.exp_content_una_definizione_1)
  map.put("exp_content_una_definizione_10", Res.string.exp_content_una_definizione_10)
  map.put("exp_content_una_definizione_11", Res.string.exp_content_una_definizione_11)
  map.put("exp_content_una_definizione_12", Res.string.exp_content_una_definizione_12)
  map.put("exp_content_una_definizione_13", Res.string.exp_content_una_definizione_13)
  map.put("exp_content_una_definizione_14", Res.string.exp_content_una_definizione_14)
  map.put("exp_content_una_definizione_15", Res.string.exp_content_una_definizione_15)
  map.put("exp_content_una_definizione_16", Res.string.exp_content_una_definizione_16)
  map.put("exp_content_una_definizione_17", Res.string.exp_content_una_definizione_17)
  map.put("exp_content_una_definizione_18", Res.string.exp_content_una_definizione_18)
  map.put("exp_content_una_definizione_2", Res.string.exp_content_una_definizione_2)
  map.put("exp_content_una_definizione_3", Res.string.exp_content_una_definizione_3)
  map.put("exp_content_una_definizione_4", Res.string.exp_content_una_definizione_4)
  map.put("exp_content_una_definizione_5", Res.string.exp_content_una_definizione_5)
  map.put("exp_content_una_definizione_6", Res.string.exp_content_una_definizione_6)
  map.put("exp_content_una_definizione_7", Res.string.exp_content_una_definizione_7)
  map.put("exp_content_una_definizione_8", Res.string.exp_content_una_definizione_8)
  map.put("exp_content_una_definizione_9", Res.string.exp_content_una_definizione_9)
  map.put("exp_content_unendo_il_primo_segno_e_il_secondo_otteniamo_", Res.string.exp_content_unendo_il_primo_segno_e_il_secondo_otteniamo_)
  map.put("exp_content_vediamo_la_lista_pane_e_birra_n_naccostiamo_p", Res.string.exp_content_vediamo_la_lista_pane_e_birra_n_naccostiamo_p)
  map.put("exp_content_vediamo_un_altro_esempio_n_la_mucca_del_pasto", Res.string.exp_content_vediamo_un_altro_esempio_n_la_mucca_del_pasto)
  map.put("exp_content_verbi_e_participi_1", Res.string.exp_content_verbi_e_participi_1)
  map.put("exp_content_verbi_e_participi_2", Res.string.exp_content_verbi_e_participi_2)
  map.put("exp_content_verbi_e_participi_3", Res.string.exp_content_verbi_e_participi_3)
  map.put("exp_content_verbi_intro_1_alyn", Res.string.exp_content_verbi_intro_1_alyn)
  map.put("exp_content_verbi_intro_1_alyn_2", Res.string.exp_content_verbi_intro_1_alyn_2)
  map.put("exp_content_verbi_intro_1_nilo_1", Res.string.exp_content_verbi_intro_1_nilo_1)
  map.put("exp_content_verbi_intro_1_nilo_2", Res.string.exp_content_verbi_intro_1_nilo_2)
  map.put("exp_content_verbi_intro_1_nilo_3", Res.string.exp_content_verbi_intro_1_nilo_3)
  map.put("exp_content_verbi_intro_1_nilo_4", Res.string.exp_content_verbi_intro_1_nilo_4)
  map.put("exp_content_verbi_intro_1_nilo_5", Res.string.exp_content_verbi_intro_1_nilo_5)
  map.put("exp_content_verbi_intro_1_nilo_6", Res.string.exp_content_verbi_intro_1_nilo_6)
  map.put("exp_content_verbi_intro_1_nilo_7", Res.string.exp_content_verbi_intro_1_nilo_7)
  map.put("exp_content_verbi_sostantivati_1", Res.string.exp_content_verbi_sostantivati_1)
  map.put("exp_content_verbi_sostantivati_10", Res.string.exp_content_verbi_sostantivati_10)
  map.put("exp_content_verbi_sostantivati_11", Res.string.exp_content_verbi_sostantivati_11)
  map.put("exp_content_verbi_sostantivati_12", Res.string.exp_content_verbi_sostantivati_12)
  map.put("exp_content_verbi_sostantivati_13", Res.string.exp_content_verbi_sostantivati_13)
  map.put("exp_content_verbi_sostantivati_14", Res.string.exp_content_verbi_sostantivati_14)
  map.put("exp_content_verbi_sostantivati_15", Res.string.exp_content_verbi_sostantivati_15)
  map.put("exp_content_verbi_sostantivati_16", Res.string.exp_content_verbi_sostantivati_16)
  map.put("exp_content_verbi_sostantivati_17", Res.string.exp_content_verbi_sostantivati_17)
  map.put("exp_content_verbi_sostantivati_18", Res.string.exp_content_verbi_sostantivati_18)
  map.put("exp_content_verbi_sostantivati_19", Res.string.exp_content_verbi_sostantivati_19)
  map.put("exp_content_verbi_sostantivati_2", Res.string.exp_content_verbi_sostantivati_2)
  map.put("exp_content_verbi_sostantivati_3", Res.string.exp_content_verbi_sostantivati_3)
  map.put("exp_content_verbi_sostantivati_4", Res.string.exp_content_verbi_sostantivati_4)
  map.put("exp_content_verbi_sostantivati_5", Res.string.exp_content_verbi_sostantivati_5)
  map.put("exp_content_verbi_sostantivati_6", Res.string.exp_content_verbi_sostantivati_6)
  map.put("exp_content_verbi_sostantivati_7", Res.string.exp_content_verbi_sostantivati_7)
  map.put("exp_content_verbi_sostantivati_8", Res.string.exp_content_verbi_sostantivati_8)
  map.put("exp_content_verbi_sostantivati_9", Res.string.exp_content_verbi_sostantivati_9)
  map.put("exp_content_verbi_vari_alyn_1", Res.string.exp_content_verbi_vari_alyn_1)
  map.put("exp_content_verbi_vari_zeta_1", Res.string.exp_content_verbi_vari_zeta_1)
  map.put("exp_content_vino_acqua_n_nil_vino_dell_acqua_non_ha_senso", Res.string.exp_content_vino_acqua_n_nil_vino_dell_acqua_non_ha_senso)
  map.put("exp_content_vino_padre_n_nil_vino_del_padre_s_ha_senso_n_", Res.string.exp_content_vino_padre_n_nil_vino_del_padre_s_ha_senso_n_)
  map.put("exp_content_vocab_animali_miit", Res.string.exp_content_vocab_animali_miit)
  map.put("exp_content_vocab_cibo_acqua", Res.string.exp_content_vocab_cibo_acqua)
  map.put("exp_content_vocab_dei_sovrani_alyn_1", Res.string.exp_content_vocab_dei_sovrani_alyn_1)
  map.put("exp_content_vocab_dei_sovrani_nilo_1", Res.string.exp_content_vocab_dei_sovrani_nilo_1)
  map.put("exp_content_vocab_famiglia_societa_alyn_1", Res.string.exp_content_vocab_famiglia_societa_alyn_1)
  map.put("exp_content_vocab_famiglia_societa_nilo_1", Res.string.exp_content_vocab_famiglia_societa_nilo_1)
  map.put("exp_content_vocab_famiglia_societa_zeta_1", Res.string.exp_content_vocab_famiglia_societa_zeta_1)
  map.put("exp_content_vocab_oggetti_sacri_alyn_1", Res.string.exp_content_vocab_oggetti_sacri_alyn_1)
  map.put("exp_content_vocab_oggetti_sacri_zeta_1", Res.string.exp_content_vocab_oggetti_sacri_zeta_1)
  map.put("exp_content_vocab_oggetti_sacri_zeta_2", Res.string.exp_content_vocab_oggetti_sacri_zeta_2)
  map.put("exp_content_vocab_umani_scriba", Res.string.exp_content_vocab_umani_scriba)
  map.put("exp_content_vocab_vari_1_alyn", Res.string.exp_content_vocab_vari_1_alyn)
  map.put("exp_content_vocab_vari_2_alyn", Res.string.exp_content_vocab_vari_2_alyn)
  map.put("exp_content_vocab_vari_2_cielo", Res.string.exp_content_vocab_vari_2_cielo)
  map.put("exp_content_vocab_varie_re_basso", Res.string.exp_content_vocab_varie_re_basso)
  map.put("exp_content_vocab_verbi_vari_alyn_1", Res.string.exp_content_vocab_verbi_vari_alyn_1)
  map.put("exp_content_vocab_verbi_vari_nilo_1", Res.string.exp_content_vocab_verbi_vari_nilo_1)
  map.put("exp_content_vocab_verbs_1_alyn", Res.string.exp_content_vocab_verbs_1_alyn)
  map.put("exp_content_vocab_verbs_1_nilo", Res.string.exp_content_vocab_verbs_1_nilo)
  map.put("exp_content_vocab_verbs_2_alyn", Res.string.exp_content_vocab_verbs_2_alyn)
  map.put("exp_content_vocab_verbs_2_nilo", Res.string.exp_content_vocab_verbs_2_nilo)
  map.put("exp_content_vocab_verbs_3_alyn", Res.string.exp_content_vocab_verbs_3_alyn)
  map.put("exp_content_vocab_verbs_3_zeta", Res.string.exp_content_vocab_verbs_3_zeta)
  map.put("exp_content_vocab_verbs_4_alyn", Res.string.exp_content_vocab_verbs_4_alyn)
  map.put("exp_content_vocab_verbs_4_zeta", Res.string.exp_content_vocab_verbs_4_zeta)
  map.put("exp_content_vocab_vso_1_alyn", Res.string.exp_content_vocab_vso_1_alyn)
}
